<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off">
        <div class="row">
          <div class="col-xl-6 mb-4">
            <label>Mã lớp <span class="text-danger">*</span></label>
            <ValidationProvider name="Mã lớp" rules="required|max:30" v-slot="{ errors }">
              <el-input v-model="form.classCode" placeholder="Nhập mã lớp" />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-xl-6 mb-4">
            <label>Trình độ học <span class="text-danger">*</span></label>
            <ValidationProvider name="Trình độ học" rules="required" v-slot="{ errors }">
              <el-select v-model="form.studyLevel" placeholder="Chọn trình độ học" class="w-100" clearable @change="handleLevelChange">
                <el-option
                  v-for="item in studyLevels"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-xl-6 mb-4">
            <label>Năng lực gia sư <span class="text-danger">*</span></label>
            <ValidationProvider name="Năng lực gia sư" rules="required" v-slot="{ errors }">
              <el-select
                v-model="form.capabilityId"
                placeholder="Chọn năng lực gia sư"
                class="w-100"
                clearable
                filterable
                :disabled="!form.studyLevel"
                :loading="loadingCapability"
              >
                <el-option
                  v-for="item in capabilityOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-xl-6 mb-4">
            <label>Link zalo hỗ trợ <span class="text-danger">*</span></label>
            <ValidationProvider name="Link zalo hỗ trợ" rules="required|zalo_url" v-slot="{ errors }">
              <el-input v-model="form.zaloLink" placeholder="Nhập link zalo hỗ trợ" />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-xl-6 mb-4">
            <label>Số lượng học viên <span class="text-danger">*</span></label>
            <ValidationProvider name="Số lượng học viên" rules="required|integer|min_value:1" v-slot="{ errors }">
              <el-input-number v-model="form.totalStudents" :min="1"  class="w-100" />
              <small class="text-danger d-block">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-xl-6 mb-4">
            <label>Ngày học <span class="text-danger">*</span></label>
            <ValidationProvider name="Ngày học" rules="required" v-slot="{ errors }">
              <el-date-picker
                v-model="form.studyDate"
                type="date"
                class="w-100"
                placeholder="Chọn ngày học"
                format="dd-MM-yyyy"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="handleDateChange"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <div class="col-xl-6 mb-4">
            <label>Giờ học <span class="text-danger">*</span></label>
            <ValidationProvider name="Giờ học" rules="required" v-slot="{ errors }">
              <el-select
                v-model="form.studyTime"
                placeholder="Chọn giờ học"
                class="w-100"
                clearable
                :disabled="!form.studyDate"
                :loading="loadingSlot"
                @focus="loadSlots"
              >
                <el-option-group
                  v-for="group in timeSlots"
                  :key="group.code"
                  :label="group.name"
                >
                  <el-option
                    v-for="item in group.slots"
                    :key="`${group.code}-${item.start}`"
                    :label="item.start"
                    :value="item.start"
                    :disabled="item.disable"
                  />
                </el-option-group>
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
            <small v-if="showOutOfSlotMessage" class="text-danger d-block mt-2">
              Ngày học đã hết slot. Vui lòng chọn ngày khác.
            </small>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <el-button @click="comeBack()">Quay lại</el-button>
          <el-button type="primary" class="ml-2" native-type="submit" :loading="submitting">
            Đặt lịch
          </el-button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import {
  GET_SLOT,
  GET_SUPPLEMENT_TUTOR_COMPETENCIES,
  POST_SUPPLEMENTARY_CLASS_TUTORING
} from '@/core/services/store/tutor/tutor.module';

export default {
  name: 'SupplementTutor',
  data() {
    return {
      submitting: false,
      loadingSlot: false,
      loadingCapability: false,
      showOutOfSlotMessage: false,
      studyLevels: [
        {id: 1, name: "Basic"},
        {id: 2, name: "PRE IELTS / GTCB"},
        {id: 3, name: "IELTS 3.5-4.5"},
        {id: 4, name: "IELTS 4.5-5.5"},
        {id: 5, name: "IELTS 5.5-6.5"}
      ],
      capabilityOptions: [],
      timeSlots: [],
      form: {
        classCode: '',
        studyLevel: '',
        capabilityId: '',
        zaloLink: '',
        totalStudents: 1,
        studyDate: '',
        studyTime: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return moment(time).isBefore(moment().startOf('day'));
        }
      }
    };
  },
  methods: {
    comeBack() {
      this.$emit('closeModal', false);
    },
    closeModal(isCreateSuccessful = false) {
      this.$emit('closeModal', isCreateSuccessful);
    },
    async handleLevelChange() {
      const selectedLevel = this.form.studyLevel;

      this.form.capabilityId = '';
      this.capabilityOptions = [];
      this.loadingCapability = false;

      if (!selectedLevel) {
        return;
      }

      this.loadingCapability = true;

      try {
        const response = await this.$store.dispatch(GET_SUPPLEMENT_TUTOR_COMPETENCIES, {
          admin_level_id: selectedLevel
        });

        if (this.form.studyLevel === selectedLevel) {
          this.capabilityOptions = response?.data || [];
        }
      } catch (error) {
        if (this.form.studyLevel === selectedLevel) {
          this.$message.error(error?.data?.message || 'Không thể tải danh sách năng lực gia sư');
        }
      } finally {
        if (this.form.studyLevel === selectedLevel) {
          this.loadingCapability = false;
        }
      }
    },
    handleDateChange() {
      this.form.studyTime = '';
      this.timeSlots = [];
      this.showOutOfSlotMessage = false;
    },
    async loadSlots() {
      if (!this.form.studyDate) {
        return;
      }

      this.timeSlots = [];
      this.loadingSlot = true;

      try {
        const response = await this.$store.dispatch(GET_SLOT, {
          subtype: 8,
          day: this.form.studyDate,
          duration: 90
        });
        const slots = response?.data?.slots || [];
        const now = Date.now();

        this.timeSlots = [
          { code: 'morning', name: 'Buổi sáng' },
          { code: 'afternoon', name: 'Buổi chiều' },
          { code: 'evening', name: 'Buổi tối' }
        ].map((shift) => ({
          ...shift,
          slots: slots
            .filter((slot) => slot.code === shift.code)
            .map((slot) => ({
              ...slot,
              start: this.formatTime(slot.start),
              disable: new Date(slot.start).getTime() < now
            }))
        }));
        this.showOutOfSlotMessage = !slots.some((slot) => new Date(slot.start).getTime() >= now);
      } catch (error) {
        this.showOutOfSlotMessage = false;
        this.$message.error(error?.data?.message || 'Không thể tải danh sách giờ học');
      } finally {
        this.loadingSlot = false;
      }
    },
    formatTime(isoString, timezone = 'Asia/Ho_Chi_Minh') {
      return moment.tz(isoString, timezone).format('HH:mm:ss');
    },
    async onSubmit() {
      const payload = {
        admin_level_id: this.form.studyLevel,
        competency_id: this.form.capabilityId,
        study_date: this.form.studyDate,
        study_time: this.form.studyTime,
        class_code: this.form.classCode,
        zalo_link: this.form.zaloLink,
        capacity: this.form.totalStudents
      };

      this.submitting = true;

      try {
        await this.$store.dispatch(POST_SUPPLEMENTARY_CLASS_TUTORING, payload);
        this.$message.success('Đặt lịch gia sư bổ trợ thành công');
        this.closeModal(true);
      } catch (error) {
        this.$message.error(error?.data?.message || 'Có lỗi xảy ra');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
